// extracted by mini-css-extract-plugin
module.exports = {"subtexto":"styles_subtexto__0_z4b","title":"styles_title__l06s2","desktopOnly":"styles_desktopOnly__B_NTc"};